// OrderFlowMyNetwork
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import '../learning/styles/Training.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';

const OrderFlowMyNetwork = () => {
    const authState = useSelector(state => state.authReducer);
    const [userId, setUserId] = useState(authState.user._id);
    const [userCode, setUserCode] = useState(authState.user.think5whyscode);
    const [myMLMCharts, setMyMLMCharts] = useState([]);
    const [fetchData, { loading }] = useFetch();
    const [selectedMLMChartId, setSelectedMLMChartId] = useState([]);
    const [expandedProductId, setExpandedProductId] = useState(null);
    const [downTheLineGetAllCountClicked, setDownTheLineGetAllCountClicked] = useState(false);
    const [downTheLineGetYTDCountClicked, setDownTheLineGetYTDCountClicked] = useState(false);
    const [downTheLineGetMTDCountClicked, setDownTheLineGetMTDCountClicked] = useState(false);
    const [downTheLineGetLastSevenDaysCountClicked, setDownTheLineGetLastSevenDaysCountClicked] = useState(false);
    const [downTheLineGetTodayCountClicked, setDownTheLineGetTodayCountClicked] = useState(false);
    const [downTheLineGetCustomCountClicked, setDownTheLineGetCustomCountClicked] = useState(false);
    
    const [downTheLineGetCount, setDownTheLineGetCount] = useState({
        l1: { count: 0, totalCom: 0 },
        l2: { count: 0, totalCom: 0 },
        l3: { count: 0, totalCom: 0 },
        l4: { count: 0, totalCom: 0 },
        l5: { count: 0, totalCom: 0 },
        l6: { count: 0, totalCom: 0 },
        l7: { count: 0, totalCom: 0 },
        l8: { count: 0, totalCom: 0 }
    });
    
    const buttonStyle = {
      marginLeft: '10px',
      padding: '5px 10px',
      fontSize: '14px',
      cursor: 'pointer',
      borderRadius: '5px',
      border: 'none',
      backgroundColor: '#25D366',
      color: '#fff'
    };

    
    
    const fetchMyMLMChart = useCallback(() => {
        const config = { 
          url: "/orderflowmlmchart/mycharts", 
          method: "post", 
          headers: { Authorization: authState.token }, 
          data: {userCode: userCode}
        };
        // console.log("My MLM Request Config: ",config)
    
        fetchData(config, { showSuccessToast: false })
        .then(({ mlmCharts }) => setMyMLMCharts(mlmCharts))
        .catch(error => console.error("Error fetching data:", error));
    
    }, [authState.token, fetchData]);
    
    useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchMyMLMChart();
    }, [authState.isLoggedIn, fetchMyMLMChart]);
  
    const sortedMyMLMCharts = [...myMLMCharts].sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));
     
    const handleMyMLMChartView = (_id) => {
      setSelectedMLMChartId(prevId => (prevId === _id ? null : _id));
    };

    const handleExpandCollapse = (productId) => {
        setExpandedProductId(expandedProductId === productId ? null : productId);
    };
    
    const calculateCommission = (advisorCode, comAmount) => {
    return advisorCode * comAmount;
    };

    const groupedCharts = sortedMyMLMCharts.reduce((acc, mlmchart) => {
        const { productId } = mlmchart;
        if (!acc[productId]) {
            acc[productId] = [];
        }
        acc[productId].push(mlmchart);
        return acc;
    }, {});
  
    const formatDateTime = (date) => {
      const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      };
      const jsDate = new Date(date);
      const day = jsDate.getDate().toString().padStart(2, '0');
      const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
      const year = jsDate.getFullYear();
      const hours = jsDate.getHours().toString().padStart(2, '0');
      const minutes = jsDate.getMinutes().toString().padStart(2, '0');
      const seconds = jsDate.getSeconds().toString().padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    const handleDownTheLineGetAllCount = (selectedBookId) => {
        setDownTheLineGetAllCountClicked(true);
        const fromDate = new Date().toISOString().split('T')[0];;
        const toDate = new Date().toISOString().split('T')[0];;
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'A', fromDate, toDate);
    };

    const fetchDownTheLineGetCount = useCallback((selectedBookId, myUserCode, myUserId, dateRangeType, fromDate, toDate) => {
        setBookId(selectedBookId);
        setMyUserCode(myUserCode);
        if (!selectedBookId || !myUserCode || !myUserId || !dateRangeType || !fromDate || !toDate) {
            return;
        }
        const config = {
            url: "/mlmchart/downthelinecount",
            method: "post",
            headers: { Authorization: authState.token },
            data: { 
                bookId: selectedBookId, 
                userCode: myUserCode, 
                userId: myUserId, 
                dateRangeType: dateRangeType, 
                fromDate: fromDate,
                toDate: toDate 
            }
        };
        // console.log("Request Payload:", { selectedBookId, myUserCode, myUserId, dateRangeType, fromDate, toDate }); // Log the payload
        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("response from referral list endpoint: ", response);

                if (response && response.referralsCount) {
                    setDownTheLineGetCount(response.referralsCount);
                } else {
                    console.error("Invalid response format: Down The Line Referral Count not found in response");
                    setDownTheLineGetCount({
                        l1: { count: 0, totalCom: 0 },
                        l2: { count: 0, totalCom: 0 },
                        l3: { count: 0, totalCom: 0 },
                        l4: { count: 0, totalCom: 0 },
                        l5: { count: 0, totalCom: 0 },
                        l6: { count: 0, totalCom: 0 },
                        l7: { count: 0, totalCom: 0 },
                        l8: { count: 0, totalCom: 0 }
                    });
                }
            })
            .catch(error => {
                console.error("Error fetching Down The Line  Referral Count:", error);
                setDownTheLineGetCount({
                    l1: { count: 0, totalCom: 0 },
                    l2: { count: 0, totalCom: 0 },
                    l3: { count: 0, totalCom: 0 },
                    l4: { count: 0, totalCom: 0 },
                    l5: { count: 0, totalCom: 0 },
                    l6: { count: 0, totalCom: 0 },
                    l7: { count: 0, totalCom: 0 },
                    l8: { count: 0, totalCom: 0 }
                });
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
            // fetchDownTheLineGetCount(bookId, myUserCode, userId, dateRangeType, fromDate, toDate); 
    }, [setDownTheLineGetCount, fetchDownTheLineGetCount]);

    return (
        <MainLayout>
        <div>
            <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>OrderFlow - My MLM I</h2>
        </div>        
        <div className="my-2 mx-auto max-w-[700px] py-4">
            <div className="flex flex-col border-b border-b-gray-300">
                <div>
                    <h3 className='text-m mt-1 mx-1 text-yellow-200'>
                        My MLM Products Referrals:  ({myMLMCharts.length})
                    </h3>
                </div>
                {loading ? (
                <Loader />
                ) : (
                    <div className="flex flex-col text-purple-500 text-sm">
                    {sortedMyMLMCharts.length === 0 ? (
                      <div className='flex justify-center my-4 p-4 text-yellow-300 text-lg rounded-md shadow-md border-b-2'>
                        No Referrals found!!
                      </div>
                    ) : (
                      Object.keys(groupedCharts).map((productId, index) => (
                        <div key={productId} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md'>
                          <div className='flex flex-row items-center'>
                            <span>{index + 1}. </span>
                            <span className='ml-2'>{groupedCharts[productId][0].productName}</span>
                            <span 
                              className='ml-auto mr-4 text-blue-500 cursor-pointer'
                              onClick={() => handleExpandCollapse(productId)}
                            >
                              {expandedProductId === productId ? '-' : '+'}
                            </span>
                          </div>
                          {expandedProductId === productId && (
                            <div className='bg-gray-200 text-black mt-2 p-2 rounded'>
                              {groupedCharts[productId].map((mlmchart, i) => (
                                <div key={mlmchart._id} className='mb-2 text-black'>
                                    <div className="mt-2 justify-center">
                                        <button
                                            className="py-1 text-white rounded bg-orange-500"
                                            onClick={() => handleDownTheLineGetAllCount(book.bookId)}
                                            disabled={downTheLineGetAllCountClicked}
                                        >
                                            Show Lifetime Count
                                        </button>
                                        {downTheLineGetAllCountClicked && downTheLineGetCount && (
                                            <div className="book-list-container ml-8 mt-2 text-red-800 overflow-x-auto">
                                            <div className="overflow-x-auto">
                                                <table className="responsive-table">
                                                <thead className="bg-gray-800">
                                                    <tr>
                                                    <th className="py-3 px-4 uppercase font-semibold text-sm">
                                                        Level
                                                    </th>
                                                    <th className="py-3 px-4 uppercase font-semibold text-sm">
                                                        Members
                                                    </th>
                                                    <th className="py-3 px-4 uppercase font-semibold text-sm">
                                                        Commission
                                                    </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-700">
                                                    <tr>
                                                    <td className="py-3 px-4">Level 1</td>
                                                    <td className="py-3 px-4">
                                                        {downTheLineGetCount.l1.count}
                                                    </td>
                                                    <td className="py-3 px-4">
                                                        {parseFloat(
                                                        downTheLineGetCount.l1.totalCom
                                                        ).toFixed(2)}
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                    <td className="py-3 px-4">Level 2</td>
                                                    <td className="py-3 px-4">
                                                        {downTheLineGetCount.l2.count}
                                                    </td>
                                                    <td className="py-3 px-4">
                                                        {parseFloat(
                                                        downTheLineGetCount.l2.totalCom
                                                        ).toFixed(2)}
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                    <td className="py-3 px-4">Level 3</td>
                                                    <td className="py-3 px-4">
                                                        {downTheLineGetCount.l3.count}
                                                    </td>
                                                    <td className="py-3 px-4">
                                                        {parseFloat(
                                                        downTheLineGetCount.l3.totalCom
                                                        ).toFixed(2)}
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                    <td className="py-3 px-4">Level 4</td>
                                                    <td className="py-3 px-4">
                                                        {downTheLineGetCount.l4.count}
                                                    </td>
                                                    <td className="py-3 px-4">
                                                        {parseFloat(
                                                        downTheLineGetCount.l4.totalCom
                                                        ).toFixed(2)}
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                    <td className="py-3 px-4">Level 5</td>
                                                    <td className="py-3 px-4">
                                                        {downTheLineGetCount.l5.count}
                                                    </td>
                                                    <td className="py-3 px-4">
                                                        {parseFloat(
                                                        downTheLineGetCount.l5.totalCom
                                                        ).toFixed(2)}
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                    <td className="py-3 px-4">Level 6</td>
                                                    <td className="py-3 px-4">
                                                        {downTheLineGetCount.l6.count}
                                                    </td>
                                                    <td className="py-3 px-4">
                                                        {parseFloat(
                                                        downTheLineGetCount.l6.totalCom
                                                        ).toFixed(2)}
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                    <td className="py-3 px-4">Level 7</td>
                                                    <td className="py-3 px-4">
                                                        {downTheLineGetCount.l7.count}
                                                    </td>
                                                    <td className="py-3 px-4">
                                                        {parseFloat(
                                                        downTheLineGetCount.l7.totalCom
                                                        ).toFixed(2)}
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                    <td className="py-3 px-4">Level 8</td>
                                                    <td className="py-3 px-4">
                                                        {downTheLineGetCount.l8.count}
                                                    </td>
                                                    <td className="py-3 px-4">
                                                        {parseFloat(
                                                        downTheLineGetCount.l8.totalCom
                                                        ).toFixed(2)}
                                                    </td>
                                                    </tr>
                                                    <tr className="bg-yellow-600">
                                                    <td className="py-3 px-4 font-semibold">Total</td>
                                                    <td className="py-3 px-4 font-semibold">
                                                        {totalCount}
                                                    </td>
                                                    <td className="py-3 px-4 font-semibold">
                                                        {totalCommission.toFixed(2)}
                                                    </td>
                                                    </tr>
                                                </tbody>
                                                </table>
                                            </div>
                                            </div>
                                        )}
                                        </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))
                    )}
                  </div>
                )}
            </div>
        </div>
    </MainLayout>
    );
};

export default OrderFlowMyNetwork;
